import { Connection, Keypair, PublicKey } from "@solana/web3.js";
import { Account } from "@solana/spl-token";

const bs58 = require('bs58');
const web3 =  require('@solana/web3.js');
const splToken = require('@solana/spl-token');

global.Buffer = global.Buffer || require('buffer').Buffer;

export async function TokenXfer(walletKey: string, tokenAddr: string, amount: number) {

    console.log('purchasing nft to ' + walletKey);

    const nftReciver = new PublicKey(walletKey);
    const tokenMintAddress = new PublicKey(tokenAddr);
    const bankKeypair = web3.Keypair.fromSecretKey(bs58.decode(process.env.REACT_APP_BANK_PRIVATE_KEY));

    //Create connection to mainnet
    const connection = new web3.Connection(web3.clusterApiUrl('mainnet-beta'));

    console.log('my splToken.getOrCreateAssociatedTokenAccount...')
    let my_token_account = await splToken.getOrCreateAssociatedTokenAccount(
        connection,
        bankKeypair,
        tokenMintAddress,
        bankKeypair.publicKey,
    );

    console.log('rcv splToken.getOrCreateAssociatedTokenAccount...')
    let reciver_token_account = await splToken.getOrCreateAssociatedTokenAccount(
        connection,
        bankKeypair,
        tokenMintAddress,
        nftReciver,
    );

    console.log('My token account public address: ' + my_token_account.address.toBase58());
    console.log('Reciver token account public address: ' + reciver_token_account.address.toBase58());

    try {
        await transfer_tokens(
            bankKeypair,
            connection,
            amount,
            reciver_token_account,
            my_token_account,
        )
    } catch (error) {
        console.log(error)
    }

    console.log('Done!');
}

async function transfer_tokens(wallet: Keypair, connection: Connection, amount: number, reciver_token_account: Account, from_token_account: Account) {
    //if tx takes more when 60 sec to complete you will receive error here
    const transfer_tx = await splToken.transfer(
        connection,
        wallet,
        from_token_account.address,
        reciver_token_account.address,
        wallet,
        amount,
        [wallet],
        false,
        splToken.TOKEN_PROGRAM_ID,
    )

    console.log(transfer_tx)

    console.log("Transcation signature", transfer_tx);
    console.log("Success!(we assume)");

}
